/* global minDate maxDate canManage activityTypes projectSourceCategory projectSourceType projectSourceId eventSlug */
/* global projectPlanListUsersUrl projectPlanDeleteAllPlans */
/* global updateProjectOwnerUrl projectOwner canEditProjectOwner */
/* global projectPlanSavedFilters saveProjectPlanFiltersUrl fetchProjectPlanScheduleUrl saveProjectPlanScheduleTargetUrl projectPlanScheduleTargetId */
/* global fetchProjectGanttChartUrl fetchProjectGanttChartLinksUrl moveProjectGanttChartUrl exportProjectPlanUrl importProjectPlanUrl deleteProjectPlanUrl */
/* global fetchProjectActivityUrl updateProjectActivityUrl storeProjectActivityUrl */
/* global fetchProjectActivityActionsUrl fetchProjectResourcesUrl fetchProjectActivityResourcesUrl allocateProjectResourcesUrl  */
/* global fetchProjectActivityDependenciesUrl searchProjectActivityDependencyCandidatesUrl searchProjectCategoryDependencyCandidatesUrl dependencyTypes */
/* global storeProjectCategoryUrl updateProjectCategoryUrl updateProjectCategoryOwnerUrl updateProjectActivityOwnerUrl categoryStatuses activityCompletenessStatuses */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ProjectPlanPage from './ProjectPlanPage';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { ProjectPeriodProvider } from 'Context/project_plan/ProjectPeriodContext';
import { ProjectPlanProvider } from 'Context/project_plan/ProjectPlanContext';
import { UsersProvider } from 'Context/UsersContext';

const SourcedProjectIndex = (props) => {
    return (
        <div className="tw-h-full">
            <ProjectPeriodProvider minDate={props.minDate} maxDate={props.maxDate} eventSlug={props.eventSlug}>
                <ProjectPlanProvider
                    fetchProjectGanttChartUrl={props.fetchProjectGanttChartUrl}
                    fetchProjectGanttChartLinksUrl={props.fetchProjectGanttChartLinksUrl}
                    moveProjectGanttChartUrl={props.moveProjectGanttChartUrl}
                    updateProjectCategoryOwnerUrl={props.updateProjectCategoryOwnerUrl}
                    updateProjectActivityOwnerUrl={props.updateProjectActivityOwnerUrl}
                    deleteProjectPlanUrl={props.deleteProjectPlanUrl}
                    fetchProjectResourcesUrl={props.fetchProjectResourcesUrl}
                    fetchProjectActivityResourcesUrl={props.fetchProjectActivityResourcesUrl}
                    allocateProjectResourcesUrl={props.allocateProjectResourcesUrl}
                    fetchProjectActivityDependenciesUrl={props.fetchProjectActivityDependenciesUrl}
                    searchProjectActivityDependencyCandidatesUrl={props.searchProjectActivityDependencyCandidatesUrl}
                    searchProjectCategoryDependencyCandidatesUrl={props.searchProjectCategoryDependencyCandidatesUrl}
                    dependencyTypes={props.dependencyTypes}
                    statuses={props.categoryStatuses}
                    completenessStatuses={props.activityCompletenessStatuses}
                    canManage={props.canManage}
                    activityTypes={props.activityTypes}
                    projectSourceType={props.projectSourceType}
                    projectSourceId={props.projectSourceId}
                    projectSourceCategory={props.projectSourceCategory}
                    savedFilters={props.savedFilters}
                    saveFiltersUrl={props.saveFiltersUrl}
                    fetchScheduleUrl={props.fetchScheduleUrl}
                    saveScheduleTargetUrl={props.saveScheduleTargetUrl}
                    savedScheduleTargetId={props.savedScheduleTargetId}
                >
                    <ProjectPlanPage
                        exportProjectPlanUrl={props.exportProjectPlanUrl}
                        importProjectPlanUrl={props.importProjectPlanUrl}
                        storeProjectCategoryUrl={props.storeProjectCategoryUrl}
                        updateProjectCategoryUrl={props.updateProjectCategoryUrl}
                        fetchProjectActivityUrl={props.fetchProjectActivityUrl}
                        storeProjectActivityUrl={props.storeProjectActivityUrl}
                        updateProjectActivityUrl={props.updateProjectActivityUrl}
                        fetchProjectActivityActionsUrl={props.fetchProjectActivityActionsUrl}
                        updateProjectOwnerUrl={props.updateProjectOwnerUrl}
                        projectOwner={props.projectOwner}
                        canEditProjectOwner={props.canEditProjectOwner}
                        deleteAllPlans={props.deleteAllPlans}
                    />
                </ProjectPlanProvider>
            </ProjectPeriodProvider>
        </div>
    );
};

if (document.getElementById('SourcedProjectIndex')) {
    var root = document.getElementById('SourcedProjectIndex');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <UsersProvider fetchUrl={projectPlanListUsersUrl}>
                    <SourcedProjectIndex
                        minDate={minDate}
                        maxDate={maxDate}
                        fetchProjectGanttChartUrl={fetchProjectGanttChartUrl}
                        fetchProjectGanttChartLinksUrl={fetchProjectGanttChartLinksUrl}
                        moveProjectGanttChartUrl={moveProjectGanttChartUrl}
                        updateProjectCategoryOwnerUrl={updateProjectCategoryOwnerUrl}
                        updateProjectActivityOwnerUrl={updateProjectActivityOwnerUrl}
                        deleteProjectPlanUrl={deleteProjectPlanUrl}
                        categoryStatuses={categoryStatuses}
                        activityCompletenessStatuses={activityCompletenessStatuses}
                        canManage={canManage}
                        activityTypes={activityTypes}
                        exportProjectPlanUrl={exportProjectPlanUrl}
                        importProjectPlanUrl={importProjectPlanUrl}
                        storeProjectCategoryUrl={storeProjectCategoryUrl}
                        updateProjectCategoryUrl={updateProjectCategoryUrl}
                        fetchProjectActivityUrl={fetchProjectActivityUrl}
                        storeProjectActivityUrl={storeProjectActivityUrl}
                        updateProjectActivityUrl={updateProjectActivityUrl}
                        fetchProjectActivityActionsUrl={fetchProjectActivityActionsUrl}
                        fetchProjectResourcesUrl={fetchProjectResourcesUrl}
                        fetchProjectActivityResourcesUrl={fetchProjectActivityResourcesUrl}
                        allocateProjectResourcesUrl={allocateProjectResourcesUrl}
                        fetchProjectActivityDependenciesUrl={fetchProjectActivityDependenciesUrl}
                        searchProjectActivityDependencyCandidatesUrl={searchProjectActivityDependencyCandidatesUrl}
                        searchProjectCategoryDependencyCandidatesUrl={searchProjectCategoryDependencyCandidatesUrl}
                        dependencyTypes={dependencyTypes}
                        projectSourceCategory={projectSourceCategory}
                        projectSourceType={projectSourceType}
                        projectSourceId={projectSourceId}
                        eventSlug={eventSlug}
                        savedFilters={projectPlanSavedFilters}
                        saveFiltersUrl={saveProjectPlanFiltersUrl}
                        fetchScheduleUrl={fetchProjectPlanScheduleUrl}
                        saveScheduleTargetUrl={saveProjectPlanScheduleTargetUrl}
                        savedScheduleTargetId={projectPlanScheduleTargetId}
                        updateProjectOwnerUrl={updateProjectOwnerUrl}
                        projectOwner={projectOwner}
                        canEditProjectOwner={canEditProjectOwner}
                        deleteAllPlans={projectPlanDeleteAllPlans}
                    />
                </UsersProvider>
            </ConfirmationModalProvider>
        </App>,
        root,
    );
}

export default SourcedProjectIndex;
